import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';

import { Category } from '@swf/core/types/StarsCoinReward';

import {
  TXTWCL_XtitleXPlay_Prize_GamesX_title_ELL,
  TXTWCL_XtitleXPlay_your_spinsX_titleX_ELL,
  TXTWCL_XtitleXTrack_your_Instant_Bonu_ELL,
  TXTWCL_XtitleXVisit_your_Rewards_Stor_ELL
} from './Title.messages.json';
import styles from './Title.scss';

const values = {
  title: (...chunks: ReactNode[]) => <h1 className={styles.title}>{chunks}</h1>,
  subtitle: (msg: ReactNode) => <h2 className={styles.subtitle}>{msg}</h2>
};

const categories = {
  [Category.Rewards]: (
    <Translation {...TXTWCL_XtitleXVisit_your_Rewards_Stor_ELL} values={values} />
  ),
  [Category.IB]: <Translation {...TXTWCL_XtitleXTrack_your_Instant_Bonu_ELL} values={values} />,
  [Category.FSB]: <Translation {...TXTWCL_XtitleXPlay_your_spinsX_titleX_ELL} values={values} />,
  [Category.SpinOfDay]: (
    <Translation {...TXTWCL_XtitleXPlay_Prize_GamesX_title_ELL} values={values} />
  )
};

const Title: React.FC<{ category: Category; className?: string }> = ({ category, className }) => (
  <span className={classNames(styles.container, className)}>{categories[category]}</span>
);

export default Title;
